import {ExtranetModule} from './extranet-module.enum';

export const ModuleClaimMap: Map<ExtranetModule, string> = new Map<ExtranetModule, string>(
  [
    [ExtranetModule.Shipment, 'extranet_modules_access_shipmentservice'],
    [ExtranetModule.Agencies, 'extranet_modules_access_agenciesservice'],
    [ExtranetModule.Settlements, 'settlements'],
    [ExtranetModule.Logistics, 'extranet_module_access_logistics'],
    [ExtranetModule.SampleApplication, 'extranet_modules_access_sampleapplication']
  ]
);
